<template>
  <div id="app">
    <NavBar />
    <main>
      <router-view/>
    </main>
    <SiteFooter v-if="features.footer" />
    <CookieConsent />
  </div>
</template>

<script>
import NavBar from "./components/navbar/NavBar.vue"
import SiteFooter from "./components/footer/SiteFooter.vue"
import CookieConsent from "./components/CookieConsent.vue"
import { features } from "./config/features"

export default {
  name: 'App',
  components: {
    NavBar,
    SiteFooter,
    CookieConsent,
  },
  data() {
    return {
      features,
    };
  },
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
main {
  flex: 1;
}
</style>
